import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

import './styles.css';

const propTypes = {
  loading: PropTypes.bool.isRequired,
};

const TransitionBackground = ({ loading }) => (
  <div className={`transition-background-container ${!loading ? 'loaded' : ''}`}>
    <div className="star-16" />
    <div className="star-17" />
    <div className="star-18" />
    <div className="star-19" />
    <div className="star-20" />
    <div className="star-21" />
    <div className="star-22" />
    <div className={`${isMobile ? 'mobile' : ''} transition-ground-container`}>
      <div className="transition-floor-background" />
      <div className="transition-florest-floor" />
    </div>
  </div>
);

TransitionBackground.propTypes = propTypes;

export default TransitionBackground;
